import React, { Component } from 'react';
import {
	Button,
	Col,
	Fade,
	Row
} from 'reactstrap';
import axios from 'axios';

import servShi from '../img/services/serv-shi-small.jpg';
import servTai from '../img/services/serv-tai-small.jpg';
import servLea from '../img/services/serv-lea-small.jpg';
import servWed from '../img/services/serv-wed-small.jpg';
import servUni from '../img/services/serv-uni-small.jpg';
import servBox from '../img/services/serv-box-small.jpg';
// import servDra from '../img/services/serv-dra.jpeg';
// import servCom from '../img/services/serv-dra.jpeg';
// import servSam from '../img/services/serv-sam.jpeg';
// import servFre from '../img/services/serv-fre.jpeg';

const ITEM_COUNT = 11;

export default class Services extends Component {
	constructor(props) {
		super(props);

		this.toggleFade = this.toggleFade.bind(this);

		this.state = {
			active: false,
			fadeIn: [],
			fadeSwitched: [],
			fading: false,
			items: [
			{
				title: "Shirts Laundered on Premises",
				header: "",
				img: servShi,
				description: "For that clean, crisp look of a professionally laundered shirt, make sure you bring them to Ecofresh Cleaners. Whether you prefer no starch or a heavy starch, our special detergents, additives and finishes will keep your garments looking their best. Collars come cleaner and professional pressing gives them a crisp look. We'll check your buttons and replace them if necessary, free of charge."
			},
			{
				title: "Tailoring & Alterations",
				header: "",
				img: servTai,
				description: "Whether you’re ordering an unfinished item from a catalog, or your diet and exercise plan means that your clothes are feeling a little loose lately. Ecofresh Cleaners offers one of the finest alteration and repair services around. From plain to cuffed slack to hemlines and sleeves lengths zippers repaired, a snap replaced or tuck here or there. Visit one of expert tailors for a fitting or consultation."
			},
			{
				title: "Leather & Suede Cleaned",
				header: "",
				img: servLea,
				description: "From that masculine bomber jacket to satiny kidskin gloves, Ecofresh Cleaners offers the finest care and expert cleaning of suede and leathers. Well work to restore the color and the feel and return your jacket looking brand new."
			},
			{
				title: "Wedding Gowns",
				header: "Cleaned & Preserved",
				img: servWed,
				description: "Most brides want to preserve their dress as a keepsake, perhaps for their own daughter to wear on her wedding day. Cleaning industry experts recommend that you have your dress cleaned and preserved before storage. We'll clean and preserve your wedding gown so your treasure will last for years to come."
			},
			{
				title: "Uniform Service",
				header: "",
				img: servUni,
				description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
			},
			{
				title: "Free Box Storage",
				header: "Free your closet space",
				img: servBox,
				description: "Closets Full? Ecofresh Cleaners is proud to offer free storage for you’re out of season garments. This means that you no longer have to struggle with crammed closets and wrinkled clothes. As the snow melts, well clean and store your winter woodland when the leaves turn colors well do the same with your delicate summer silks."
			},
			// {
			// 	title: "Drapery & Area Rugs Cleaning",
			// 	header: "",
			// 	img: servDra,
			// 	description: "When doing your spring cleaning this year remember Ecofresh Cleaners to help refresh your home. We can help by professionally dry cleaning and press your draperies. Don’t forget to bring in your area rugs too! They’ll look, feel and smell fabulous!"
			// },
			// {
			// 	title: "Comforters, Sleeping Bags, & Bed Pillows",
			// 	header: "",
			// 	img: servCom,
			// 	description: "Thinking of buying a new comforter or blanket! Wait! Let us give them a good cleaning. Well also clean your sleeping bags and provide you with a free zippered storage bag. Bring in your pillows and well send them back fresh and clean with new ticking."
			// },
			// {
			// 	title: "Same Day Service",
			// 	header: "",
			// 	img: servSam,
			// 	description: "Need a quick, dependable, one day service? We proudly offer same day service Monday thru Saturday. Get your cleaning in by 9am and well have it back to you at 5pm! It’s convenient and best of all, doesn’t cost you anything extra!"
			// },
			// {
			// 	title: "Free Pickup & Delivery",
			// 	header: "",
			// 	img: servFre,
			// 	description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
			// },
			// {
			// 	title: "Shoe Repair",
			// 	header: "",
			// 	img: servFre,
			// 	description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry."
			// },
			]
		}
	}

	toggleFade(i) {
		if (!this.state.fading) {
			const fadeInArr = this.state.fadeIn.slice().fill(!this.state.fadeIn[i], i, i + 1);
			const fadeSwitchedArr = this.state.fadeSwitched.slice().fill(!this.state.fadeSwitched[i], i, i + 1);

			this.setState({ fadeIn: fadeInArr, fading: !this.state.fading });
			setTimeout(function() {
				this.setState({ fadeSwitched: fadeSwitchedArr, fading: !this.state.fading });
			}.bind(this), 250);
		}
	}

	get() {
		if (process.env.REACT_APP_FRONT_END === "true") {
			return;
		}
		axios.get('/api/services')
		.then((res) => {
			console.log(res);
			this.setState({
				active: res.data.active,
			})
		})
		.catch((err) => {
			console.log(err);
			this.setState({ active: false });
		});
	}
	componentDidMount() {
		this.get();

		const fadeInArr = Array(ITEM_COUNT).fill(true);
		const fadeSwitchedArr = Array(ITEM_COUNT).fill(true);

		this.setState({ fadeIn: fadeInArr, fadeSwitched: fadeSwitchedArr });
	}

	render() {
		if (!this.state.active) {
			return (
              <Row>
                {
                  this.state.items.map((item, index) =>
                    <Col xs={12} md={6} lg={4} key={index.toString()}>
                      <div className="feature-item">
                        {this.state.fadeSwitched[index] ? (
                          <Fade in={this.state.fadeIn[index]}>
                            <img src={item.img} alt={item.title} className="img-fluid"/>
                            {/*<h3>{item.title}</h3>*/}
                            {/*<Button onClick={() => this.toggleFade(index)} className="mt-3" style={{cursor: "pointer"}}>More info</Button>*/}
                          </Fade>
                        ) : (
                          <Fade in={!this.state.fadeIn[index]}>
                            <h3>{item.title}</h3>
                            <p className="text-muted">{item.description}</p>
                            <Button onClick={() => this.toggleFade(index)} className="mt-3" style={{cursor: "pointer"}}>Back</Button>
                          </Fade>
                        )}
                      </div>
                    </Col>
                  )
                }
              </Row>
			)
		}
		return (
			<div>

			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/components/Services.js